export const startOfLocalDay = (value: Date = new Date()): Date =>
    new Date(value.getFullYear(), value.getMonth(), value.getDate());

export const addDays = (value: Date, days: number): Date => {
    const next = startOfLocalDay(value);
    next.setDate(next.getDate() + days);
    return next;
};

export const startOfWeekMonday = (value: Date = new Date()): Date => {
    const start = startOfLocalDay(value);
    const offset = (start.getDay() + 6) % 7;
    start.setDate(start.getDate() - offset);
    return start;
};

export const endOfWeekSunday = (value: Date = new Date()): Date => addDays(startOfWeekMonday(value), 6);

export const formatDateKey = (value: Date): string => {
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatMonthKey = (value: Date): string =>
    `${value.getFullYear()}-${`${value.getMonth() + 1}`.padStart(2, '0')}`;

export const formatShortMonthDay = (value: Date): string =>
    `${value.getMonth() + 1}/${value.getDate()}`;

export const currentMonthBounds = (value: Date = new Date()) => {
    const monthStart = new Date(value.getFullYear(), value.getMonth(), 1);
    const monthEnd = new Date(value.getFullYear(), value.getMonth() + 1, 0);
    return {
        monthStart,
        monthEnd,
        previousMonthStart: new Date(value.getFullYear(), value.getMonth() - 1, 1),
        previousMonthEnd: new Date(value.getFullYear(), value.getMonth(), 0),
    };
};
